import * as React from 'react';
import { Spin } from 'antd';

interface IProps {
  fileName?: string;
  width?: number;
  height?: number;
}

export const ImageLoadingPlaceholder: React.FC<IProps> = ({
  fileName = 'Uploading...',
  width = 300,
  height = 200
}) => {
  return (
    <div
      className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-md bg-gray-50 hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 my-2"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        minHeight: '120px'
      }}
    >
      <Spin size="large" />
      <div className="mt-3 text-center">
        <div className="text-gray-600 text-sm">Uploading Content...</div>
        <div className="text-gray-500 text-xs mt-1 opacity-70">
          {fileName}
        </div>
      </div>
    </div>
  );
};

ImageLoadingPlaceholder.displayName = 'ImageLoadingPlaceholder';
